/* eslint-disable react/no-danger */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Body from './Body';

import styles from '../../../styles/partials/text.module.scss';

// @TODO
// - remove all the "replaceUrbaniaWithLogo" stuff if we never end up using it?

const propTypes = {
    dropCap: PropTypes.bool,
    indent: PropTypes.bool,
    replaceUrbaniaWithLogo: PropTypes.bool,
    body: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    dropCap: false,
    indent: false,
    replaceUrbaniaWithLogo: false,
    body: null,
    className: null,
};

const Text = ({ dropCap, indent, replaceUrbaniaWithLogo, body, className }) => {
    const finalBody = useMemo(() => {
        if (!dropCap) {
            return body;
        }

        const bodyString = body || '';
        const strippedBody = bodyString.replace(/(<([^>]+)>)/gi, '');
        const firstWord = strippedBody.split(' ')[0];
        const isFirstWordUrbania = firstWord.toLowerCase().startsWith('urbania');
        const firstWordLastPart = firstWord.substr(isFirstWordUrbania ? 2 : 1);
        const firstWordWithDropCap = `<span class="${styles.dropCap}">${
            isFirstWordUrbania
                ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.09 29.8">
                        <path d="M6.46,28.36a10.4,10.4,0,0,1-4.82-4.22A13.07,13.07,0,0,1,0,17.4V0H10.4V17a5,5,0,0,0,.44,2.18,3,3,0,0,0,1.3,1.36A4.26,4.26,0,0,0,14.2,21a4.26,4.26,0,0,0,2.06-.46,3,3,0,0,0,1.3-1.36A5,5,0,0,0,18,17V0H28.4V17.4a13.07,13.07,0,0,1-1.64,6.74,10.4,10.4,0,0,1-4.82,4.22A18.7,18.7,0,0,1,14.2,29.8,18.7,18.7,0,0,1,6.46,28.36Z" fill="currentColor"/>
                        <path d="M37.15,28.76a6.82,6.82,0,0,1-2.44-1.86A8.14,8.14,0,0,1,33.17,24l-.72-2.4a5.17,5.17,0,0,0-.9-1.76,1.85,1.85,0,0,0-1.5-.64H28.49l-10.4,9.6V0H33.81a17,17,0,0,1,6.46,1.1,8.49,8.49,0,0,1,4,3.24,9.45,9.45,0,0,1,1.38,5.22A8.24,8.24,0,0,1,45,12.9a7.93,7.93,0,0,1-2,2.7,9.71,9.71,0,0,1-3.18,1.84v0a3.13,3.13,0,0,1,1.58,1,6.12,6.12,0,0,1,.94,1.92l.48,1.6a2.3,2.3,0,0,0,.58,1,1.27,1.27,0,0,0,.94.38,2.41,2.41,0,0,0,.76-.14,6,6,0,0,0,.72-.3l1.24,4.52A9.22,9.22,0,0,1,44,28.9a14.42,14.42,0,0,1-3.78.5A7.38,7.38,0,0,1,37.15,28.76Zm-5.1-16a4.39,4.39,0,0,0,1.76-.32,2.35,2.35,0,0,0,1.1-1A3,3,0,0,0,35.29,10a3,3,0,0,0-.38-1.52,2.35,2.35,0,0,0-1.1-1,4.39,4.39,0,0,0-1.76-.32H28.49v5.6Z" fill="currentColor"/>
                    </svg>`
                : `<span>${firstWord.substr(0, 1)}</span>`
        }</span>${firstWordLastPart}`;

        return bodyString.replace(firstWord, firstWordWithDropCap);
    }, [body, dropCap, replaceUrbaniaWithLogo]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.withIndent]: indent,
                },
            ])}
        >
            <Body
                className={styles.body}
                body={finalBody}
                urbaniaLogoAsImage={replaceUrbaniaWithLogo}
            />
        </div>
    );
};

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export default Text;
